// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.document-uploader-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.document-uploader-content {
  background: white;
  border-radius: 8px;
  padding: 30px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.document-uploader-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.document-uploader-header h3 {
  margin: 0;
  color: #333;
  font-size: 20px;
}

.close-button {
  background: transparent;
  border: none;
  font-size: 28px;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
  line-height: 1;
}

.close-button:hover {
  background: #f5f5f5;
  color: #333;
}

.close-button:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.upload-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1976d2;
}

.form-group small {
  font-size: 12px;
  color: #666;
}

.file-upload-area {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  background: #f9f9f9;
  transition: all 0.2s;
  cursor: pointer;
}

.file-upload-area.dragging {
  border-color: #1976d2;
  background: #e3f2fd;
}

.file-upload-area.has-file {
  border-color: #4caf50;
  background: #e8f5e9;
}

.upload-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.browse-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
}

.upload-hint {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}

.file-selected {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
}

.file-name {
  font-weight: 600;
  color: #333;
}

.file-size {
  color: #666;
  font-size: 12px;
}

.remove-file {
  background: #f44336;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remove-file:hover {
  background: #d32f2f;
}

.preview-loading {
  text-align: center;
  padding: 10px;
  color: #666;
  font-size: 14px;
}

.file-preview {
  margin-top: 15px;
  padding: 15px;
  background: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.file-preview strong {
  display: block;
  margin-bottom: 10px;
  color: #333;
}

.file-preview pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 12px;
  color: #666;
  max-height: 200px;
  overflow-y: auto;
}

.preview-note {
  font-size: 11px;
  color: #999;
  margin-top: 5px;
  font-style: italic;
}

.upload-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 10px;
}

.upload-submit,
.upload-cancel {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
}

.upload-submit {
  background: #1976d2;
  color: white;
}

.upload-submit:hover:not(:disabled) {
  background: #1565c0;
}

.upload-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.upload-cancel {
  background: #f5f5f5;
  color: #333;
}

.upload-cancel:hover {
  background: #e0e0e0;
}

.upload-progress-container {
  margin-top: 15px;
  margin-bottom: 10px;
}

.upload-progress-bar {
  width: 100%;
  height: 8px;
  background: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.upload-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #1976d2, #42a5f5);
  border-radius: 4px;
  transition: width 0.3s ease;
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.3);
}

.upload-progress-text {
  text-align: center;
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

@media (max-width: 768px) {
  .document-uploader-content {
    padding: 20px;
    width: 95%;
  }
  
  .file-upload-area {
    padding: 30px 20px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/admin/components/DocumentUploader.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".document-uploader-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.document-uploader-content {\n  background: white;\n  border-radius: 8px;\n  padding: 30px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.document-uploader-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.document-uploader-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 20px;\n}\n\n.close-button {\n  background: transparent;\n  border: none;\n  font-size: 28px;\n  color: #666;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n  line-height: 1;\n}\n\n.close-button:hover {\n  background: #f5f5f5;\n  color: #333;\n}\n\n.close-button:focus {\n  outline: 2px solid #1976d2;\n  outline-offset: 2px;\n}\n\n.upload-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #1976d2;\n}\n\n.form-group small {\n  font-size: 12px;\n  color: #666;\n}\n\n.file-upload-area {\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  padding: 40px;\n  text-align: center;\n  background: #f9f9f9;\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.file-upload-area.dragging {\n  border-color: #1976d2;\n  background: #e3f2fd;\n}\n\n.file-upload-area.has-file {\n  border-color: #4caf50;\n  background: #e8f5e9;\n}\n\n.upload-icon {\n  font-size: 48px;\n  margin-bottom: 10px;\n}\n\n.browse-link {\n  color: #1976d2;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.upload-hint {\n  font-size: 12px;\n  color: #666;\n  margin-top: 10px;\n}\n\n.file-selected {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n}\n\n.file-name {\n  font-weight: 600;\n  color: #333;\n}\n\n.file-size {\n  color: #666;\n  font-size: 12px;\n}\n\n.remove-file {\n  background: #f44336;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.remove-file:hover {\n  background: #d32f2f;\n}\n\n.preview-loading {\n  text-align: center;\n  padding: 10px;\n  color: #666;\n  font-size: 14px;\n}\n\n.file-preview {\n  margin-top: 15px;\n  padding: 15px;\n  background: #f5f5f5;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n}\n\n.file-preview strong {\n  display: block;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.file-preview pre {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-size: 12px;\n  color: #666;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.preview-note {\n  font-size: 11px;\n  color: #999;\n  margin-top: 5px;\n  font-style: italic;\n}\n\n.upload-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.upload-submit,\n.upload-cancel {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.upload-submit {\n  background: #1976d2;\n  color: white;\n}\n\n.upload-submit:hover:not(:disabled) {\n  background: #1565c0;\n}\n\n.upload-submit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.upload-cancel {\n  background: #f5f5f5;\n  color: #333;\n}\n\n.upload-cancel:hover {\n  background: #e0e0e0;\n}\n\n.upload-progress-container {\n  margin-top: 15px;\n  margin-bottom: 10px;\n}\n\n.upload-progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e0e0e0;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.upload-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #1976d2, #42a5f5);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.3);\n}\n\n.upload-progress-text {\n  text-align: center;\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n}\n\n@media (max-width: 768px) {\n  .document-uploader-content {\n    padding: 20px;\n    width: 95%;\n  }\n  \n  .file-upload-area {\n    padding: 30px 20px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
